import type { FC } from 'react'

import type { AgentChatMessage } from '~/api/agentChat'

import { MarkdownRenderer } from './MarkdownComponents'
import { MessageAttachment } from './MessageAttachment'
import { MessageBubble } from './MessageBubble'

import styles from './ChatMessage.module.scss'

/** Strip HTML comments for display only */
const stripHtmlComments = (content: string): string =>
  content
    .replace(/<!--[\s\S]*?-->/g, '')
    .replace(/&lt;!--[\s\S]*?--&gt;/g, '')
    // Normalize excessive blank lines for nicer display
    .replace(/\n{3,}/g, '\n\n')
    .trim()

interface UserMessageBubbleProps {
  message: AgentChatMessage
  sessionId: string | null
}

export const UserMessageBubble: FC<UserMessageBubbleProps> = ({
  message,
  sessionId,
}) => (
  <MessageBubble sender="user">
    <MarkdownRenderer
      content={stripHtmlComments(message.content)}
      sessionId={sessionId}
    />
    {message.attachments?.map((attachment, idx) => (
      <MessageAttachment
        attachment={attachment}
        // eslint-disable-next-line react/no-array-index-key
        key={`${message.id}-${attachment.mimeType}-${idx}`}
      />
    ))}
    <div className={styles.messageTimestamp}>{message.timestamp}</div>
  </MessageBubble>
)

export default UserMessageBubble
